var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLocation = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 26 26"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13 21.7c-.3 0-.6-.1-.9-.4-1.6-2-5.3-6.9-5.3-10.6 0-3.5 2.8-6.3 6.3-6.3s6.3 2.8 6.3 6.3c0 3.7-3.8 8.6-5.4 10.6-.4.2-.7.4-1 .4m0-16.2c-2.9 0-5.2 2.4-5.2 5.2 0 3.5 4 8.4 5.2 9.8h.2c1.3-1.5 5.2-6.4 5.2-9.8-.2-2.9-2.5-5.2-5.4-5.2"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.9 13.7c-1.4 0-2.5-1.2-2.5-2.5s1.2-2.5 2.5-2.5 2.5 1.2 2.5 2.5-1 2.5-2.5 2.5m0-4.1c-.8 0-1.5.6-1.5 1.5 0 .8.6 1.5 1.5 1.5.8 0 1.5-.6 1.5-1.5 0-.7-.7-1.5-1.5-1.5"
})));
export default SvgLocation;